// import React, { useState } from "react";
// import { Box, Card, Chip, Grid, Paper, Stack, Typography } from "@mui/material";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";

// export default function TimeslotsTab({ beautician }) {
//   return (
//     <Box>
//       <Grid item xs={12} md={12}>
//         <Card
//           sx={{
//             p: 4,
//             borderRadius: 6,
//             boxShadow: 8,
//             background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
//           }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1} mb={2}>
//             <AccessTimeIcon color="primary" />
//             <Typography variant="h6" fontWeight={600}>
//               Weekly TimeSlots
//             </Typography>
//           </Stack>

//           {beautician?.userSlot?.length > 0 ? (
//             <Grid container spacing={3}>
//               {beautician.userSlot.map((daySlot, index) => (
//                 <Grid item xs={12} sm={6} md={4} key={index}>
//                   <Paper
//                     elevation={3}
//                     sx={{
//                       p: 2,
//                       borderRadius: 4,
//                       backgroundColor: daySlot.active ? "#ffffff" : "#f5f5f5",
//                     }}
//                   >
//                     {/* <EditIcon
//                         color="primary"
//                         sx={{ position: "absolute", top: 16, right: 16 }}
//                         onClick={() => setTimeSlots(true)}
//                       /> */}
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       gutterBottom
//                       sx={{ textTransform: "capitalize", color: "#3f51b5" }}
//                     >
//                       {daySlot.day}
//                     </Typography>

//                     {daySlot.slots?.length > 0 ? (
//                       <Stack spacing={1}>
//                         {daySlot.slots.map((slot, i) => (
//                           <Chip
//                             key={i}
//                             label={`${slot.start} - ${slot.end}`}
//                             color={slot.active ? "success" : "default"}
//                             variant="outlined"
//                             sx={{ width: "fit-content" }}
//                           />
//                         ))}
//                       </Stack>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No slots available.
//                       </Typography>
//                     )}
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             <Typography>No time slots available.</Typography>
//           )}
//         </Card>
//       </Grid>
//     </Box>
//   );
// }
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Card,
//   Grid,
//   Paper,
//   Stack,
//   Typography,
//   Chip,
//   Button,
//   TextField,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import {
//   getTimeSlotsApi,
//   addTimeSlotApi,
//   updateTimeSlotApi,
//   deleteTimeSlotApi,
// } from "services/beuticainTimeSlotApi";

// const allDays = [
//   "monday",
//   "tuesday",
//   "wednesday",
//   "thursday",
//   "friday",
//   "saturday",
//   "sunday",
// ];

// export default function TimeslotsTab({ beautician }) {
//   const [slots, setSlots] = useState(beautician?.userSlot || []);
//   const [loading, setLoading] = useState(false);
//   const [open, setOpen] = useState(false);
//   const [selectedDay, setSelectedDay] = useState("");
//   const [start, setStart] = useState("");
//   const [end, setEnd] = useState("");

//   const fetchSlots = async () => {
//     setLoading(true);
//     try {
//       const data = await getTimeSlotsApi();
//       setSlots(data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSlots();
//   }, []);

//   // Calculate remaining days dynamically
//   const usedDays = slots.map((s) => s.day);
//   const remainingDays = allDays.filter((d) => !usedDays.includes(d));

//   const handleSave = async () => {
//     try {
//       const existing = slots.find((s) => s.day === selectedDay);

//       const payload = {
//         day: selectedDay,
//         slots: [{ start, end }],
//         active: true,
//       };

//       if (existing) {
//         await updateTimeSlotApi(existing._id, payload);
//       } else {
//         await addTimeSlotApi(payload);
//       }

//       setOpen(false);
//       setStart("");
//       setEnd("");
//       fetchSlots();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const handleDelete = async (id) => {
//     if (window.confirm("Delete this slot?")) {
//       await deleteTimeSlotApi(id);
//       fetchSlots();
//     }
//   };

//   return (
//     <Box>
//       <Grid item xs={12}>
//         <Card
//           sx={{
//             p: 4,
//             borderRadius: 6,
//             boxShadow: 8,
//             background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
//           }}
//         >
//           <Stack direction="row" alignItems="center" spacing={1} mb={2}>
//             <AccessTimeIcon color="primary" />
//             <Typography variant="h6" fontWeight={600}>
//               Weekly TimeSlots
//             </Typography>
//             <Box flexGrow={1} />

//             {/* Only show Add Slot button if not all days are added */}
//             {remainingDays.length > 0 && (
//               <Button
//                 variant="contained"
//                 onClick={() => setOpen(true)}
//                 color="primary"
//               >
//                 Add Slot
//               </Button>
//             )}
//           </Stack>

//           {loading ? (
//             <CircularProgress />
//           ) : slots.length > 0 ? (
//             <Grid container spacing={3}>
//               {slots.map((daySlot, index) => (
//                 <Grid item xs={12} sm={6} md={4} key={index}>
//                   <Paper
//                     elevation={3}
//                     sx={{
//                       p: 2,
//                       borderRadius: 4,
//                       backgroundColor: "#fff",
//                       position: "relative",
//                     }}
//                   >
//                     <Typography
//                       variant="subtitle1"
//                       fontWeight={600}
//                       gutterBottom
//                       sx={{ textTransform: "capitalize", color: "#3f51b5" }}
//                     >
//                       {daySlot.day}
//                     </Typography>

//                     {daySlot.slots?.length > 0 ? (
//                       <Stack spacing={1}>
//                         {daySlot.slots.map((slot, i) => (
//                           <Chip
//                             key={i}
//                             label={`${slot.start} - ${slot.end}`}
//                             color={slot.active ? "success" : "default"}
//                             variant="outlined"
//                             sx={{ width: "fit-content" }}
//                           />
//                         ))}
//                       </Stack>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No slots available.
//                       </Typography>
//                     )}
//                     <Stack direction="row" spacing={1} mt={2}>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         onClick={() => {
//                           setSelectedDay(daySlot.day);
//                           setOpen(true);
//                         }}
//                       >
//                         Edit
//                       </Button>
//                       <Button
//                         variant="outlined"
//                         size="small"
//                         color="error"
//                         onClick={() => handleDelete(daySlot._id)}
//                       >
//                         Delete
//                       </Button>
//                     </Stack>
//                   </Paper>
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             <Typography>No time slots available.</Typography>
//           )}
//         </Card>
//       </Grid>

//       {/* Dialog for Add/Edit */}
//       <Dialog open={open} onClose={() => setOpen(false)}>
//         <DialogTitle>Add or Update Slot</DialogTitle>
//         <DialogContent>
//           <TextField
//             select
//             label="Day"
//             fullWidth
//             margin="normal"
//             value={selectedDay}
//             onChange={(e) => setSelectedDay(e.target.value)}
//           >
//             {(selectedDay ? [selectedDay] : remainingDays).map((day) => (
//               <MenuItem key={day} value={day}>
//                 {day.charAt(0).toUpperCase() + day.slice(1)}
//               </MenuItem>
//             ))}
//           </TextField>

//           <TextField
//             label="Start Time"
//             type="time"
//             fullWidth
//             margin="normal"
//             value={start}
//             onChange={(e) => setStart(e.target.value)}
//           />
//           <TextField
//             label="End Time"
//             type="time"
//             fullWidth
//             margin="normal"
//             value={end}
//             onChange={(e) => setEnd(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)}>Cancel</Button>
//           <Button
//             variant="contained"
//             onClick={handleSave}
//             disabled={!start || !end || !selectedDay}
//           >
//             Save
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }
import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Grid,
  Paper,
  Stack,
  Typography,
  Chip,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  IconButton,
  CircularProgress,
  Divider,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  getTimeSlotsApi,
  addTimeSlotApi,
  updateTimeSlotApi,
  deleteTimeSlotApi,
} from "services/beuticainTimeSlotApi";

const days = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export default function TimeslotsTab({ beautician }) {
  const [slots, setSlots] = useState(beautician?.userSlot || []);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");
  const [daySlots, setDaySlots] = useState([{ start: "", end: "" }]);
  const [editingId, setEditingId] = useState(null);

  // Fetch slots from API
  const fetchSlots = async () => {
    setLoading(true);
    try {
      const data = await getTimeSlotsApi(beautician._id);
      setSlots(data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSlots();
  }, []);

  const normalizeTime = (time) => {
    if (!time) return "";

    // Case 1: "09:00:00" → "09:00"
    if (/^\d{2}:\d{2}:\d{2}$/.test(time)) {
      return time.slice(0, 5);
    }

    // Case 2: "9:00 AM" → "09:00"
    if (
      time.toLowerCase().includes("am") ||
      time.toLowerCase().includes("pm")
    ) {
      const [raw, period] = time.split(" ");
      let [h, m] = raw.split(":").map(Number);
      if (period.toLowerCase() === "pm" && h < 12) h += 12;
      if (period.toLowerCase() === "am" && h === 12) h = 0;
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    }

    // Case 3: already good
    return time;
  };

  // Open dialog for Add or Edit
  const handleOpenDialog = (daySlot = null) => {
    if (daySlot) {
      setSelectedDay(daySlot.day);
      setDaySlots(
        daySlot.slots.map((s) => ({
          start: normalizeTime(s.start),
          end: normalizeTime(s.end),
        }))
      );
      setEditingId(daySlot._id);
    } else {
      setSelectedDay("");
      setDaySlots([{ start: "", end: "" }]);
      setEditingId(null);
    }
    setOpen(true);
  };

  // Add a new start–end time field
  const handleAddSlotField = () => {
    setDaySlots([...daySlots, { start: "", end: "" }]);
  };

  // Remove a slot field
  const handleRemoveSlotField = (index) => {
    const updated = [...daySlots];
    updated.splice(index, 1);
    setDaySlots(updated);
  };

  // Handle slot input change
  const handleSlotChange = (index, field, value) => {
    const updated = [...daySlots];
    updated[index][field] = value;
    setDaySlots(updated);
  };

  // Save new or updated slots
  const handleSave = async () => {
    try {
      const payload = {
        day: selectedDay,
        slots: daySlots,
        active: true,
      };

      if (editingId) {
        await updateTimeSlotApi(beautician._id, editingId, payload);
      } else {
        await addTimeSlotApi(beautician._id, payload);
      }

      setOpen(false);
      fetchSlots();
    } catch (err) {
      console.error(err);
    }
  };

  // Delete a day slot
  const handleDelete = async (id) => {
    if (window.confirm("Delete this slot?")) {
      await deleteTimeSlotApi(id);
      fetchSlots();
    }
  };

  // Remaining days not yet added
  const remainingDays = days.filter((d) => !slots.some((s) => s.day === d));

  return (
    <Box>
      <Grid item xs={12}>
        dffsdfgsdfgsdfgsdfg
        <Card
          sx={{
            p: 4,
            borderRadius: 6,
            boxShadow: 8,
            background: "linear-gradient(to right, #fdf7e8ff, #e3f1c3ff)",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1} mb={2}>
            <AccessTimeIcon color="primary" />
            <Typography variant="h6" fontWeight={600}>
              Weekly TimeSlots
            </Typography>
            <Box flexGrow={1} />
            {remainingDays.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleOpenDialog()}
              >
                Add Slot
              </Button>
            )}
          </Stack>

          {loading ? (
            <CircularProgress />
          ) : slots.length > 0 ? (
            <Grid container spacing={3}>
              {slots.map((daySlot, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      backgroundColor: "#fff",
                      position: "relative",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      gutterBottom
                      sx={{ textTransform: "capitalize", color: "#3f51b5" }}
                    >
                      {daySlot.day}
                    </Typography>

                    {daySlot.slots?.length > 0 ? (
                      <Stack spacing={1}>
                        {daySlot.slots.map((slot, i) => (
                          <Chip
                            key={i}
                            label={`${slot.start} - ${slot.end}`}
                            color={slot.active ? "success" : "default"}
                            variant="outlined"
                            sx={{ width: "fit-content" }}
                          />
                        ))}
                      </Stack>
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No slots available.
                      </Typography>
                    )}

                    <Stack direction="row" spacing={1} mt={2}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => handleOpenDialog(daySlot)}
                      >
                        Edit
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => handleDelete(daySlot._id)}
                      >
                        Delete
                      </Button>
                    </Stack>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography>No time slots available.</Typography>
          )}
        </Card>
      </Grid>

      {/* Dialog for Add/Edit Slots */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {editingId ? `Edit Slots for ${selectedDay}` : "Add Time Slots"}
        </DialogTitle>

        <DialogContent>
          {!editingId && (
            <TextField
              select
              label="Select Day"
              fullWidth
              margin="normal"
              value={selectedDay}
              onChange={(e) => setSelectedDay(e.target.value)}
            >
              {remainingDays.map((day) => (
                <MenuItem key={day} value={day}>
                  {day.charAt(0).toUpperCase() + day.slice(1)}
                </MenuItem>
              ))}
            </TextField>
          )}

          {editingId && (
            <Typography
              variant="subtitle1"
              sx={{ mt: 2, fontWeight: 600, textTransform: "capitalize" }}
            >
              {selectedDay}
            </Typography>
          )}

          <Divider sx={{ my: 1 }} />

          {daySlots.map((slot, index) => (
            <Stack
              key={index}
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ mt: 1 }}
            >
              <TextField
                label="Start Time"
                type="time"
                value={slot.start}
                onChange={(e) =>
                  handleSlotChange(index, "start", e.target.value)
                }
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="End Time"
                type="time"
                value={slot.end}
                onChange={(e) => handleSlotChange(index, "end", e.target.value)}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
              <IconButton
                color="error"
                disabled={daySlots.length === 1}
                onClick={() => handleRemoveSlotField(index)}
                sx={{ color: "black !important " }}
              >
                <DeleteIcon />
              </IconButton>
            </Stack>
          ))}

          <Button
            startIcon={<AddCircleOutlineIcon />}
            onClick={handleAddSlotField}
            sx={{
              mt: 2,
              color: "black !important ",
              border: "1px solid black",
            }}
          >
            Add More
          </Button>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            sx={{ color: "black !important", border: "1px solid black" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!selectedDay || daySlots.some((s) => !s.start || !s.end)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
